<p-inputNumber mode="decimal"
               [useGrouping]="false"
               [maxlength]="maxLength"
               [allowEmpty]="allowEmpty"
               [tabindex]="tabindex"
               (focusin)="selectAll($event)"
               [placeholder]="placeholder"

               [ngModel]="value"
               (ngModelChange)="onNgModelChange($event)"
               (onBlur)="onDataChanged()"

               [inputStyleClass]="inputStyleClass"
               [disabled]="disabled"
               [class]="class"
               [class.text-center]="textCenter"
               [class.p-inputnumber-xs]="small"
               [styleClass]="styleClass"
               [class.p-inputgroup-right]="classInputgroupRight"/>
